"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./OptionsPaneError.scss');
var OptionsPaneError = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneError, _super);
    function OptionsPaneError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneError.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", { className: owa_options_strings_1.default.optionsFull_subCategory_error })));
    };
    return OptionsPaneError;
}(React.Component));
exports.default = OptionsPaneError;
//# sourceMappingURL=OptionsPaneError.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionsPaneError.js
// module id = 5304
// module chunks = 2